import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GenericTabs, { TabOption } from "@ui-components/Tabs/GenericTabs";

const deviceClusterTabRoutes: Record<string, string> = {
  "Device View": "/reflector-v2/management/bgp-reflectors",
  "Cluster View": "/reflector-v2/management/clusters",
};

const licensingTabRoutes: Record<string, string> = {
  "Paid Licenses": "/reflector-v2/management/licensing",
  "PAYG": "/reflector-v2/management/licensing/payg",
};

const ReflectorsTabs: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine which tab set to use
  const isLicensing =
    location.pathname === "/reflector-v2/management/licensing" ||
    location.pathname === "/reflector-v2/management/licensing/payg" 
  const tabRoutes = isLicensing ? licensingTabRoutes : deviceClusterTabRoutes;
  const tabOptions: TabOption[] = Object.keys(tabRoutes).map((tab) => ({ label: tab, value: tab }));

  // Find the active tab based on the current route or query
  let activeTab = tabOptions[0].value;
  if (isLicensing) {
    if (location.pathname === "/reflector-v2/management/licensing/payg") {
      activeTab = "PAYG";
    } else {
      activeTab = "Paid Licenses";
    }
  } else {
    activeTab = Object.keys(tabRoutes).find((tab) => location.pathname === tabRoutes[tab]) || tabOptions[0].value;
  }

  const handleTabChange = (tab: string) => {
    navigate(tabRoutes[tab]);
  };

  return (
    <div className="flex items-center justify-start max-w-[400px]">
      <GenericTabs
        tabs={tabOptions}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

export default ReflectorsTabs;
